export default __webpack_public_path__ + "static/2-163044c79d5e2a49a5a39b8e231c8e92.jpeg";